import { useSearchParams } from "react-router-dom";
import { Auth } from "aws-amplify";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { Laptop } from "react-bootstrap-icons";
import styles from "./LoginPage.module.css";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const { redirect } = Object.fromEntries(searchParams);
  if (redirect) {
    localStorage.setItem("redirect", redirect);
  } else {
    localStorage.removeItem("redirect");
  }

  const handleLogin = () => {
    return Auth.federatedSignIn({
      customProvider: process.env.REACT_APP_OAUTH_PROVIDER ?? "",
    });
  };

  return (
    <Container className={styles.loginForm}>
      <Row>
        <Laptop />
        Login
        <Button onClick={() => handleLogin()}>Sign In</Button>
      </Row>
    </Container>
  );
}
